import React from 'react';
import {
  SpeedDial,
  Badge,
  useTheme,
} from '@mui/material';
import {
  Assessment,
  ErrorOutline,
} from '@mui/icons-material';
import { useHomeIntelligenceContext } from '../../../contexts/HomeIntelligenceContext';
import { getScoreCategoryInfo } from '../../../../shared/intelligence/types.js';

interface IntelligenceSpeedDialProps {
  onClick: () => void;
}

export const IntelligenceSpeedDial: React.FC<IntelligenceSpeedDialProps> = ({
  onClick
}) => {
  const theme = useTheme();
  const { intelligence, error } = useHomeIntelligenceContext();

  // Show error state if there's an error and no intelligence data
  if (error && !intelligence) {
    return (
      <SpeedDial
        ariaLabel="Property Intelligence Error"
        sx={{
          position: 'fixed',
          bottom: 85,
          right: 16,
          zIndex: theme.zIndex.speedDial,
        }}
        icon={<ErrorOutline />}
        onClick={onClick}
        FabProps={{
          size: 'medium',
          color: 'error',
        }}
      />
    );
  }

  // Don't render if no intelligence data
  if (!intelligence) {
    return null;
  }

  const { color } = getScoreCategoryInfo(intelligence.propertyScore.overall);

  return (
    <SpeedDial
      ariaLabel="Property Intelligence"
      sx={{
        position: 'fixed',
        bottom: 85,
        right: 16,
        zIndex: theme.zIndex.speedDial,
      }}
      icon={
        <Badge
          badgeContent={Math.round(intelligence.propertyScore.overall)}
          sx={{
            '& .MuiBadge-badge': {
              backgroundColor: color,
              color: 'white',
              fontWeight: 600,
              fontSize: '0.75rem',
            },
          }}
        >
          <Assessment />
        </Badge>
      }
      onClick={onClick}
      FabProps={{
        size: 'medium',
        sx: {
          backgroundColor: color,
          '&:hover': {
            backgroundColor: color,
          },
        },
      }}
    />
  );
};

export default IntelligenceSpeedDial;
